import * as angular from 'angular';

import { Injectable, Inject } from 'ng-metadata/core';

export interface ProcessingTraveler {
  id: string;
  options: {};
  addons: string [];
  name: string;
  outbound?: string;
  required: boolean;
  residency: string;
  confirmed: boolean;
  citizenship: string;
}

@Injectable('VisaProcessingService')
export class VisaProcessingService {
  public GW = (<any>window).GW;
  public travelers: ProcessingTraveler[] = [];

  updateTravelers(cartTravelers: ProcessingTraveler[], searchAmount: number, params) {
    // Create travelers per searched value
    if (Object.keys(cartTravelers).length === 0) {
      for (let $i = 0; $i < searchAmount; $i += 1) {
        this.addTraveler(params);
      }
    } else {
      this.travelers = angular.copy(Object.values(cartTravelers));
    }
  }

  addTraveler(params) {
    const newTraveler: ProcessingTraveler = {
      id: 't' + Math.floor(Math.random() * 1000).toString(),
      name: '',
      required: null,
      confirmed: false,
      citizenship: params.citizenship.code || this.GW.geoip.iso_code || 'US',
      residency: params.residency.code || this.GW.geoip.state || 'FL',
      options: {},
      addons: [],
    };

    // Default to California North jurisdiction for California geolocation
    if (newTraveler.residency === 'CA') {
      newTraveler.residency = 'CA-N';
    }

    this.travelers.push(newTraveler);
  }

  removeTraveler(index: number) {
    this.travelers.splice(index, 1);
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/components/visa-processing/visa-processing.service.ts